import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { TfUserDataModule, } from "@app/modules/tf-user-data";
import { TfPriceHeaderComponent } from "./components/tf-price-header/tf-price-header.component";
import { NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";


@NgModule({
    declarations: [
        TfPriceHeaderComponent
    ],
    imports: [
        CommonModule,
        TfUserDataModule,
        NgbPopoverModule
    ],
    exports: [
        TfPriceHeaderComponent
    ],

})

export class TfPriceHeaderModule {
}
